import { render, staticRenderFns } from "./OrderViewActionAccept.vue?vue&type=template&id=ef1ac922&"
import script from "./OrderViewActionAccept.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports